import React from "react";

const ProjectGallery = ({ project }) => {
  const images = project?.imageUrls || [];

  if (!images.length) {
    return null;
  }

  return (
    <div className="project-gallery">
      {images.map((url, index) => (
        <div className="gallery-image-wrapper" key={index}>
          <img
            src={url}
            alt={`Project screenshot ${index + 1}`}
            className="gallery-image"
          />
        </div>
      ))}
    </div>
  );
};

export default ProjectGallery;
